import { Component } from '@theme/component';
import { ThemeEvents, VariantUpdateEvent, ZoomMediaSelectedEvent } from '@theme/events';

export class MediaGallery extends Component {
  connectedCallback() {
    super.connectedCallback();

    const { signal } = this.#controller;
    const target = this.closest('.shopify-section, dialog');

    target?.addEventListener(ThemeEvents.variantUpdate, this.#handleVariantUpdate, { signal });
    this.refs.zoomDialogComponent?.addEventListener(ThemeEvents.zoomMediaSelected, this.#handleZoomMediaSelected, {
      signal,
    });
  }

  #controller = new AbortController();

  disconnectedCallback() {
    super.disconnectedCallback();
    this.#controller.abort();
  }

  #handleVariantUpdate = (event) => {
    const source = event.detail.data.html;
    if (!source) return;
    const newMediaGallery = source.querySelector('media-gallery');
    if (!newMediaGallery) return;
    this.replaceWith(newMediaGallery);
  };

  #handleZoomMediaSelected = async (event) => {
    this.slideshow?.select(event.detail.index, undefined, { animate: false });
  };

  zoom(index, event) {
    this.refs.zoomDialogComponent?.open(index, event);
  }

  preloadImage(index) {
    const zoomDialogMedia = this.refs.zoomDialogComponent?.refs.media[index];
    if (!zoomDialogMedia) return;
    this.refs.zoomDialogComponent?.loadHighResolutionImage(zoomDialogMedia);
  }

  /**
   * Enhanced: Selects media if the Alt text CONTAINS the color name
   */
  selectMediaByAlt(altName) {
    if (!this.media || !altName) return;

    const targetIndex = this.media.findIndex(mediaElement => {
      const img = mediaElement.querySelector('img');
      if (!img || !img.alt) return false;
      
      const imageAlt = img.alt.toLowerCase();
      const searchTerm = altName.toLowerCase().trim();
      
      // Matches if alt is "Red" or "KIVA Red Slipper"
      //return imageAlt === searchTerm || imageAlt.includes(searchTerm);
      return imageAlt === searchTerm;
    });

    if (targetIndex !== -1 && this.slideshow) {
      this.slideshow.select(targetIndex);
    }
  }

/**
   * Finds the slideshow component. 
   * If the 'ref' is missing, it looks for the custom element tag.
   */
  get slideshow() {
    return this.refs.slideshow || this.querySelector('slideshow-component, .slideshow');
  }

/**
   * Finds all media items.
   * Looks for elements with [data-media-id] or the standard shopify media class.
   */
  get media() {
    // If the theme's built-in refs fail, we grab the items manually
    const foundMedia = this.querySelectorAll('[data-media-id], .product__media-item');
    return foundMedia.length > 0 ? Array.from(foundMedia) : this.refs.media;
  }

get presentation() {
    return this.dataset.presentation;
  }
}

if (!customElements.get('media-gallery')) {
  customElements.define('media-gallery', MediaGallery);
}